export const formatCountryCode = (countryCode: string): string => {
  if (!countryCode) return countryCode;

  const cleanCode = countryCode.replace(/\D/g, '');

  return `+${cleanCode}`;
};

export const getNationalNumber = (
  phone: string,
  countryCode: string,
): string => {
  if (!phone || !countryCode) return phone;

  const cleanCountryCode = countryCode.replace(/\D/g, '');

  const cleanPhone = phone.replace(/\D/g, '');

  if (cleanPhone.startsWith(cleanCountryCode)) {
    return cleanPhone.substring(cleanCountryCode.length);
  }

  return cleanPhone;
};

export const concatenatePhoneWithCountryCode = (
  phone: string,
  countryCode: string,
): string => {
  if (!phone) return phone;
  if (!countryCode) return phone;

  const formattedCountryCode = formatCountryCode(countryCode);
  const cleanPhone = phone.replace(/\D/g, '');

  return `${formattedCountryCode}${cleanPhone}`;
};
